import {createBrowserHistory} from 'history'
import config from 'config'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import md5 from 'md5'

/*#__PURE__*/ dayjs.extend(customParseFormat)

const isE2EMode = () => {
  if (typeof window !== 'undefined') {
    return !!window.Cypress // Checking for runnig Cepress test runner while client side rendering @sinslav
  }
  return process.env.E2E_MODE === 'enabled' // Checking for env variable for SSR @sinslav
}


function isClient() {
  return typeof window !== 'undefined'
}

function ccApiUrl(endpoint, search) {
  const baseUrl = typeof window != 'undefined' ? '' : config.baseUrl

  return `${baseUrl}${config.creditCardsRoot}${
    config.apiRoot
  }/${endpoint}${search}`
}

function extractNumber(formattedAmount) {
  if (!formattedAmount) {
    return NaN
  }

  if (typeof formattedAmount === 'number') {
    return formattedAmount
  }
  const unformattedAmount = formattedAmount.replace(/[^0-9|.|-]+/g, '')

  return Number(unformattedAmount)
}

// This function does the same convertion as extractNumber but defaults to undefined when cannot convert and does not consider empty string as zero
function numberFromCurrency(string) {
  if (string === '' || string === undefined || typeof string === 'number') {
    return string
  }

  const converted = parseFloat(string.replace(/[^0-9|.|-]+/g, ''))

  if (isNaN(converted)) {
    return
  }

  return converted
}

function htmlDecode(text) {
  if (typeof text !== 'string') {
    return text
  }

  let result = text

  if (text) {
    result = result.replace('&reg;', '®')
    result = result.replace('&#174;', '®')
    result = result.replace('&trade;', '™')
    result = result.replace('&#8482;', '™')
    result = result.replace('&#8480;', '℠')
  }

  return result
}

// Remove UTM params from query string and redirect to raw URL
function cleanUtmParameters() {
  if (!global.window || !window.location.search) {
    return
  }

  const utms = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_internal',
    'utm_referrer',
    'user_agent',
    'gclid',
    'kclickid',
    'msclkid',
    'gbraid',
    'wbraid',
    'preferred_lender'
  ]

  let originalSearchParams = window.location.search,
    searchParams = window.location.search
      .replace('?', '')
      .split('&')
      .filter(param => !utms.includes(param.replace(/(=.*)/, '')))
      .join('&')

  if (originalSearchParams.length !== searchParams.length) {
    const history = createBrowserHistory(),
      redirectUrlSearch = searchParams.length && `?${searchParams}` || ''

    history.replace(`${window.location.pathname}${redirectUrlSearch}`)
  }
}

const isMobile = () => {
    if (!global.window) {
      return null
    }

    const {navigator} = global.window,
      {userAgent} = navigator || {}

    return (
      /Android/i.test(userAgent) ||
      /webOS/i.test(userAgent) ||
      /iPhone/i.test(userAgent) ||
      /iPod/i.test(userAgent) ||
      /BlackBerry/i.test(userAgent) ||
      /Windows Phone/i.test(userAgent)
    )
  },
  isTablet = () => {
    if (!global.window) {
      return null
    }

    const {navigator} = global.window,
      {userAgent} = navigator || {}

    return (
      userAgent.match(/Tablet|iPad|iPod/i) && global.window.innerWidth <= 1280
    )
  },
  isMobileWidth = () => global.window && global.window.innerWidth < 768,
  isTabletWidth = () => global.window && global.window.innerWidth < 991 && !isMobile(),
  resolve = (path, obj = {}, separator = '.') => {
    const properties = Array.isArray(path) ? path : path.split(separator)

    return properties.reduce((prev, curr) => prev && prev[curr], obj)
  },
  getCampaign = cookies => {
    const options = {doNotParse: true},
      campaign = {
        utmCampaign: cookies.get('utm_campaign', options) || 'default',
        utmMedium: cookies.get('utm_medium', options) || 'default',
        utmSource: cookies.get('utm_source', options) || 'default',
        utmInternal: cookies.get('utm_internal', options) || 'default',
        utmReferrer: cookies.get('utm_referrer', options),
        userAgent: navigator.userAgent,
        utmContent: cookies.get('utm_content', options),
        blogLanding: (cookies.get('changed_utm', options) || 'false') === 'false' ? cookies.get('blog_landing', options) || 'default' : 'default',
        blogLastpage: (cookies.get('changed_utm', options) || 'false') === 'false' && cookies.get('blog_landing', options) !== 'default' ? cookies.get('blog_lastpage', options) || 'default' : 'default',
        referralCode: cookies.get('referral_link', options),
        partner: cookies.get('partner', options),
        wbraid: cookies.get('wbraid', options),
        gbraid: cookies.get('gbraid', options),
        gclid: cookies.get('gclid', options),
        msclkid: cookies.get('msclkid', options),
        kclickid: cookies.get('kclickid', options),
        kclickDate: cookies.get('kclick_date', options),
        attributionDate: cookies.get('utm_iso_date', options),
        preferredLender: cookies.get('preferred_lender', options),
        clickUuid: cookies.get('click_uuid', options),
      }

    console.log('changed_utm type', typeof cookies.get('changed_utm', options))
    //console.log('blog_landing', !cookies.get('changed_utm', options) ? cookies.get('blog_landing', options) || 'default' : 'default')

    Object.keys(campaign).forEach(key => {
      if (campaign[key] == undefined) {
        delete campaign[key]
      }
    })

    return campaign
  },
  possessiveForm = noun => {
    if (typeof noun === 'string') {
      noun = noun.trim()

      noun = noun.toLowerCase().slice(-1) === 's'
        ? `${noun}'`
        : `${noun}'s`
    }

    return noun
  },
  pluck = (array, attribute) => array.map(o => resolve(attribute, o)),
  unique = array => array.filter((el, pos, arr) => arr.indexOf(el) === pos),
  convertDate = (fromFormat, toFormat, ignoreInvalidDate = false) => value => {
    const date = dayjs(value, fromFormat, false)

    if (ignoreInvalidDate) {
      return date.isValid() ? date.format(toFormat) : value
    }

    return date.format(toFormat)
  },
  convertShortDateInput = value => {
    // Adds a day value ('01') for shortDateInputs to pass dayjs conversion, value is passed through otherwise
    const split = value.split('/')

    return split.length !== 2 ? value : `${split[0]}/01/${split[1]}`
  },
  removeIDsFromURL = url => {
    return url.replace(/\/[RL|SL|PL|MP|MR]+-[\w]*/, '')
  },
  mergeRefs = (...inputRefs) => {
    const filteredInputRefs = inputRefs.filter(Boolean)

    if (filteredInputRefs.length <= 1) {
      const firstRef = filteredInputRefs[0]

      return firstRef || null
    }

    return function mergedRefs(ref) {
      filteredInputRefs.forEach((inputRef) => {
        if (typeof inputRef === 'function') {
          inputRef(ref)
        } else if (inputRef) {
          inputRef.current = ref
        }
      })
    }
  },
  buildApplyDirectHref = (config) => {
    const queryParams = new URLSearchParams(config)
    return `/redirect?${queryParams.toString()}`
  }

export {
  isE2EMode,
  isClient,
  ccApiUrl,
  extractNumber,
  htmlDecode,
  cleanUtmParameters,
  isMobile,
  isTablet,
  isMobileWidth,
  isTabletWidth,
  resolve,
  getCampaign,
  numberFromCurrency,
  possessiveForm,
  pluck,
  unique,
  convertDate,
  convertShortDateInput,
  removeIDsFromURL,
  mergeRefs,
  buildApplyDirectHref
}
